<template>
  <div>
    <row>
      <col3>
        <v-btn color="primary" @click="acceptAll">{{$t('suggestions.accept_all')}}</v-btn>
      </col3>
      <col3>
        <v-btn color="primary" @click="acceptSelected">{{$t('suggestions.accept_selected')}}</v-btn>
      </col3>
      <col3>
        <v-btn color="primary" @click="discardAll">{{$t('suggestions.discard_all')}}</v-btn>
      </col3>
    </row>

    <row>
      <col4 v-for="suggestion in asset.annotation_suggestions" :key="suggestion.id">
        <annotation-suggestion 
        :asset="asset" 
        :suggestion="suggestion"
        @select_toggled="selectToggled"
        @select_asset="selectGridAsset"></annotation-suggestion>
      </col4>
    </row>

  </div>
  
</template>

<script>

import AnnotationSuggestion from "@/components/AnnotationSuggestion";
import Row from "@/components/layout/Row";
import Col3 from "@/components/layout/Col3";
import Col4 from "@/components/layout/Col4";
import { canOpenAnnotateModal } from '@/utils/annotateModalGuard';

export default {
  name: "AssetSuggestions.vue",
  props: ['asset'],
  components: {AnnotationSuggestion, Row, Col3, Col4},
  data() {
    return {
      selectedSuggestionIds: [],
    }
  },
  computed: {
    allSuggestionIds() {
      return this.asset.annotation_suggestions.map(suggestion => suggestion.id);
    }
  },
  methods: {
    selectGridAsset(asset_id) {
      if (!canOpenAnnotateModal()) {
        return;
      }
      // Parent (AutoSuggestions) owns the single annotate modal so only one can open.
      this.$emit('select_asset', asset_id);
    },
    selectToggled(suggestion_id, isChecked) {
      if (isChecked) {
        this.selectedSuggestionIds.push(suggestion_id);
      } else {
        const index = this.selectedSuggestionIds.indexOf(suggestion_id);
        if (index !== -1) {
          this.selectedSuggestionIds.splice(index, 1);
        }
      }
    },
    async acceptAll() {
      await this.$api.asset.accept_suggestions(this.asset.id, this.allSuggestionIds)
      this.$emit('remove_asset_from_list', this.asset.id)
    },
    async acceptSelected() {
      await this.$api.asset.accept_suggestions(this.asset.id, this.selectedSuggestionIds)
      this.asset.annotation_suggestions = this.asset.annotation_suggestions.filter(
        suggestion => !this.selectedSuggestionIds.includes(suggestion.id)
      );
      this.selectedSuggestionIds = [];

      if (this.asset.annotation_suggestions.length === 0) {
        this.$emit('remove_asset_from_list', this.asset.id);
      }
    },
    async discardAll() {
      await this.$api.asset.discard_all_suggestions(this.asset.id)
      this.$emit('remove_asset_from_list', this.asset.id)
    }
  },
}

</script>

<style scoped>

</style>
